// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"ArrowLink__pc_only___39AFk","sp_only":"ArrowLink__sp_only___ovNJK","arrow_link":"ArrowLink__arrow_link___26wm0"};